export enum AnalystHeatmapCategoryKind {
  Text = 0,
  HourOfDay = 1,
  DayOfWeek = 2,
}
